export const CHARGER_COMMANDS = [
    // ── Session ──────────────────────────────────────────────────────────────
    {
        command: 'RemoteStartTransaction',
        label: 'Remote Start Transaction',
        group: 'Session',
        version: '1.6',
        template: { id_tag: 'FREE', connector_id: 1 },
    },
    {
        command: 'RemoteStopTransaction',
        label: 'Remote Stop Transaction',
        group: 'Session',
        version: '1.6',
        template: { transaction_id: 0 },
    },
    {
        command: 'RequestStartTransaction',
        label: 'Request Start Transaction',
        group: 'Session',
        version: '2.0.1',
        template: { id_token: { id_token: 'FREE', type: 'Central' }, remote_start_id: 1 },
    },
    {
        command: 'RequestStopTransaction',
        label: 'Request Stop Transaction',
        group: 'Session',
        version: '2.0.1',
        template: { transaction_id: '' },
    },
    {
        command: 'GetTransactionStatus',
        label: 'Get Transaction Status',
        group: 'Session',
        version: '2.0.1',
        template: { transaction_id: '' },
    },
    {
        command: 'CostUpdated',
        label: 'Cost Updated',
        group: 'Session',
        version: '2.0.1',
        template: { total_cost: 0, transaction_id: '' },
    },
    // ── Device Control ───────────────────────────────────────────────────────
    {
        command: 'Reset',
        label: 'Reset',
        group: 'Device Control',
        version: 'both',
        template16: { type: 'Soft' },
        template201: { type: 'Immediate' },
        schema16:  { type: { enum: ['Soft', 'Hard'] } },
        schema201: { type: { enum: ['Immediate', 'OnIdle'] } },
    },
    {
        command: 'ChangeAvailability',
        label: 'Change Availability',
        group: 'Device Control',
        version: 'both',
        template16: { connector_id: 1, type: 'Operative' },
        template201: { operational_status: 'Operative', evse: { id: 1 } },
        schema16:  { type: { enum: ['Operative', 'Inoperative'] } },
        schema201: { operational_status: { enum: ['Operative', 'Inoperative'] } },
    },
    {
        command: 'UnlockConnector',
        label: 'Unlock Connector',
        group: 'Device Control',
        version: 'both',
        template16: { connector_id: 1 },
        template201: { evse_id: 1, connector_id: 1 },
    },
    {
        command: 'TriggerMessage',
        label: 'Trigger Message',
        group: 'Device Control',
        version: '1.6',
        template: { requested_message: 'StatusNotification' },
        schema: {
            requested_message: {
                enum: [
                    'BootNotification',
                    'DiagnosticsStatusNotification',
                    'FirmwareStatusNotification',
                    'Heartbeat',
                    'MeterValues',
                    'StatusNotification',
                ],
            },
        },
    },
    {
        command: 'ExtendedTriggerMessage',
        label: 'Extended Trigger Message',
        group: 'Device Control',
        version: '1.6',
        template: { requested_message: 'SignChargePointCertificate' },
        schema: {
            requested_message: {
                enum: [
                    'BootNotification',
                    'DiagnosticsStatusNotification',
                    'FirmwareStatusNotification',
                    'Heartbeat',
                    'MeterValues',
                    'StatusNotification',
                    'SignChargePointCertificate',
                    'LogStatusNotification',
                    'SecurityEventNotification',
                ],
            },
        },
    },
    // ── Configuration ────────────────────────────────────────────────────────
    {
        command: 'GetConfiguration',
        label: 'Get Configuration',
        group: 'Configuration',
        version: '1.6',
        template: { key: [] },
    },
    {
        command: 'ChangeConfiguration',
        label: 'Change Configuration',
        group: 'Configuration',
        version: '1.6',
        template: { key: '', value: '' },
    },
    {
        command: 'GetVariables',
        label: 'Get Variables',
        group: 'Configuration',
        version: '2.0.1',
        template: { get_variable_data: [{ component: { name: '' }, variable: { name: '' } }] },
    },
    {
        command: 'SetVariables',
        label: 'Set Variables',
        group: 'Configuration',
        version: '2.0.1',
        template: { set_variable_data: [{ attribute_value: '', component: { name: '' }, variable: { name: '' } }] },
    },
    {
        command: 'ClearCache',
        label: 'Clear Cache',
        group: 'Configuration',
        version: 'both',
        template: {},
    },
    {
        command: 'GetBaseReport',
        label: 'Get Base Report',
        group: 'Configuration',
        version: '2.0.1',
        template: { request_id: 1, report_base: 'FullInventory' },
        schema: {
            report_base: { enum: ['ConfigurationInventory', 'FullInventory', 'SummaryInventory'] },
        },
    },
    // ── Diagnostics & Firmware ───────────────────────────────────────────────
    {
        command: 'GetDiagnostics',
        label: 'Get Diagnostics',
        group: 'Diagnostics & Firmware',
        version: '1.6',
        template: { location: '' },
    },
    {
        command: 'UpdateFirmware',
        label: 'Update Firmware',
        group: 'Diagnostics & Firmware',
        version: '1.6',
        template: { location: '', retrieve_date: '' },
    },
    {
        command: 'GetLog',
        label: 'Get Log',
        group: 'Diagnostics & Firmware',
        version: '1.6',
        template: { log: { remote_location: '' }, log_type: 'SecurityLog', request_id: 1 },
        schema: {
            log_type: { enum: ['DiagnosticsLog', 'SecurityLog'] },
        },
    },
    {
        command: 'SignedUpdateFirmware',
        label: 'Signed Update Firmware',
        group: 'Diagnostics & Firmware',
        version: '1.6',
        template: {
            request_id: 1,
            firmware: { location: '', retrieve_date_time: '', signing_certificate: '', signature: '' },
        },
    },
    // ── Scheduling ───────────────────────────────────────────────────────────
    {
        command: 'SetChargingProfile',
        label: 'Set Charging Profile',
        group: 'Scheduling',
        version: 'both',
        template16: {
            connector_id: 1,
            cs_charging_profiles: {
                charging_profile_id: 1,
                stack_level: 0,
                charging_profile_purpose: 'TxDefaultProfile',
                charging_profile_kind: 'Absolute',
                charging_schedule: {
                    charging_rate_unit: 'W',
                    charging_schedule_period: [{ start_period: 0, limit: 7400 }],
                },
            },
        },
        template201: {
            evse_id: 1,
            charging_profile: {
                id: 1,
                stack_level: 0,
                charging_profile_purpose: 'TxDefaultProfile',
                charging_profile_kind: 'Absolute',
                charging_schedule: [{
                    id: 1,
                    charging_rate_unit: 'W',
                    charging_schedule_period: [{ start_period: 0, limit: 7400 }],
                }],
            },
        },
    },
    {
        command: 'ClearChargingProfile',
        label: 'Clear Charging Profile',
        group: 'Scheduling',
        version: 'both',
        template: {},
    },
    {
        command: 'GetCompositeSchedule',
        label: 'Get Composite Schedule',
        group: 'Scheduling',
        version: '1.6',
        template: { connector_id: 1, duration: 3600 },
    },
    {
        command: 'ReserveNow',
        label: 'Reserve Now',
        group: 'Scheduling',
        version: 'both',
        template16: { connector_id: 1, expiry_date: '', id_tag: '', reservation_id: 1 },
        template201: { id: 1, expiry_date_time: '', id_token: { id_token: '', type: 'ISO14443' } },
    },
    {
        command: 'CancelReservation',
        label: 'Cancel Reservation',
        group: 'Scheduling',
        version: 'both',
        template: { reservation_id: 1 },
    },
    // ── Authorization ────────────────────────────────────────────────────────
    {
        command: 'SendLocalList',
        label: 'Send Local List',
        group: 'Authorization',
        version: '1.6',
        template: { list_version: 1, update_type: 'Full', local_authorization_list: [] },
        schema: {
            update_type: { enum: ['Full', 'Differential'] },
        },
    },
    {
        command: 'GetLocalListVersion',
        label: 'Get Local List Version',
        group: 'Authorization',
        version: '1.6',
        template: {},
    },
    // ── Security Extensions ──────────────────────────────────────────────────
    {
        command: 'GetInstalledCertificateIds',
        label: 'Get Installed Certificate IDs',
        group: 'Security Extensions',
        version: '1.6',
        template: { certificate_type: 'CentralSystemRootCertificate' },
        schema: {
            certificate_type: { enum: ['CentralSystemRootCertificate', 'ManufacturerRootCertificate', 'ClientCertificate'] },
        },
    },
    {
        command: 'InstallCertificate',
        label: 'Install Certificate',
        group: 'Security Extensions',
        version: '1.6',
        template: { certificate_type: 'CentralSystemRootCertificate', certificate: '' },
        schema: {
            certificate_type: { enum: ['CentralSystemRootCertificate', 'ManufacturerRootCertificate', 'ClientCertificate'] },
        },
    },
    {
        command: 'DeleteCertificate',
        label: 'Delete Certificate',
        group: 'Security Extensions',
        version: '1.6',
        template: {
            certificate_hash_data: {
                hash_algorithm: 'SHA256',
                issuer_name_hash: '',
                issuer_key_hash: '',
                serial_number: '',
            },
        },
    },
    {
        command: 'CertificateSigned',
        label: 'Certificate Signed',
        group: 'Security Extensions',
        version: '1.6',
        template: { certificate_chain: '' },
    },
    // ── Other ────────────────────────────────────────────────────────────────
    {
        command: 'DataTransfer',
        label: 'Data Transfer',
        group: 'Other',
        version: 'both',
        template: { vendor_id: '' },
    },
];

export const COMMAND_GROUPS = [...new Set(CHARGER_COMMANDS.map(c => c.group))];
